/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_tip_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split a 60 total between 4 people = 15 each.`)
};

const es_pct_tip_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reparte un total de 60 entre 4 personas = 15 cada una.`)
};

const de_pct_tip_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Gesamtbetrag von 60 aufgeteilt auf 4 Personen = 15 pro Person.`)
};

const nl_pct_tip_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verdeel een totaal van 60 over 4 personen = 15 per persoon.`)
};

const fr_pct_tip_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager un total de 60 entre 4 personnes = 15 chacune.`)
};

const it_pct_tip_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividi un totale di 60 tra 4 persone = 15 a testa.`)
};

const pt_br2_pct_tip_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida um total de 60 entre 4 pessoas = 15 cada.`)
};

const pt_pct_tip_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividir um total de 60 por 4 pessoas = 15 cada uma.`)
};

const ja_pct_tip_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合計60を4人で割る = 一人15。`)
};

const zh_pct_tip_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 的总额由 4 人分摊 = 每人 15。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_tip_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_tip_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_tip_ex2", locale)
	if (locale === "en") return en_pct_tip_ex2(inputs)
	if (locale === "es") return es_pct_tip_ex2(inputs)
	if (locale === "de") return de_pct_tip_ex2(inputs)
	if (locale === "nl") return nl_pct_tip_ex2(inputs)
	if (locale === "fr") return fr_pct_tip_ex2(inputs)
	if (locale === "it") return it_pct_tip_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_pct_tip_ex2(inputs)
	if (locale === "pt") return pt_pct_tip_ex2(inputs)
	if (locale === "ja") return ja_pct_tip_ex2(inputs)
	return zh_pct_tip_ex2(inputs)
};